import { $http, buildHeaders } from "./index";

//获取算税列表
export const calctax_list = (params) => {
  return $http.get("/admin/CalcTax/index", { params });
};

//获取算税单条记录
export const calctax_read = (id) => {
  return $http.get("/admin/CalcTax/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取算税工资表明细
export const calctax_detail = (data) => {
  return $http.get("/admin/CalcTax/detail", {
    data,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//提交算税
export const calctax_submit = (data) => {
  return $http.post("/admin/CalcTax/submit", data, {
    headers: buildHeaders(3),
  });
};

//取消算税
export const calctax_cancel = (data) => {
  return $http.post("/admin/CalcTax/cancel", data, {
    headers: buildHeaders(3),
  });
};

//获取算税工资表明细
export const calctax_records = (params) => {
  return $http.get("/admin/CalcTax/detail", {
    params,
  });
};

//导出
export const calctax_records_export = (params) => {
  return $http.get("/admin/CalcTax/exportDetail", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//核算员工算税
export const calctax_accounting = (params) => {
  return $http.get("/admin/CalcTax/accounting", {
    params,
  });
};

//导出
export const calctax_accounting_export = (params) => {
  return $http.get("/admin/CalcTax/exportAccounting", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
